<template>
  <div class="header-width">
    <div class="personalCenter">
      <div style="width: 642px; padding: 14px 26px">
        <div class="row">
          <div class="col-md-2">
            <div class="userimage" v-if="userInfo">
              <img :src="userInfo.avatar ? userInfo.avatar : userInfo.sex === '1' ? `https://stu8.jxjypt.cn/nan.jpg` : `https://stu8.jxjypt.cn/nv.jpg`" />
            </div>
          </div>
          <div class="col-md-10 flex-center" v-if="userInfo">
            <div>
              <div class="username">
                {{ userInfo.name }}
                <span class="grade">{{ userInfo.grade }}级</span>
                <!-- 切换学籍按钮 -->
                <span class="enroll-switch" v-if="showSwitchBtn">
                  <a-button type="link" size="small" @click="openSwitchModal">
                    <a-icon type="sync" />
                    <span>切换学籍</span>
                  </a-button>
                </span>
              </div>
              <div class="userinfo">
                专业：
                <strong class="margin-right-20">{{ userInfo.proName }}</strong>
                层次：
                <strong class="margin-right-20">{{ userInfo.learnLevel }}</strong>
                <template v-if="$store.state.homeObj.show_fee === '1'">
                  缴费状态：
                  <strong class="margin-right-20" :class="userInfo.feeFlag ? 'text-green' : 'text-red'">
                    <span v-show="userInfo.feeFlag">已缴费</span>
                    <span v-show="!userInfo.feeFlag" @click="gotoRouter" style="cursor: pointer">未缴费</span>
                  </strong>
                </template>
              </div>
              <template v-if="$store.state.homeObj.show_site_info == '1' && userInfo.isShowDepartInfo != '1'">
                <div class="site-info">
                  教学点名称：
                  <strong>{{ userInfo.siteName }}</strong>
                </div>
                <div class="site-info">
                  教学点电话：
                  <strong>{{ userInfo.sitePhone }}</strong>
                </div>
              </template>
              <template v-if="userInfo.isShowDepartInfo == '1'">
                <div class="site-info">
                  院系名称：
                  <strong>{{ userInfo.departName }}</strong>
                </div>
                <div class="site-info">
                  院系电话：
                  <strong>{{ userInfo.departPhone }}</strong>
                </div>
              </template>
              <div class="site-info" v-if="$store.state.homeObj.show_class_info == '1'">
                班级：
                <strong>{{ userInfo.vclass }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="segmentation" style="width: 60px;">
        <div class="top-semi-circle"></div>
        <div class="segmentation-center"></div>
        <div class="bottom-semi-circle"></div>
      </div>
      <div style="width: 600px">
        <div class="row icons">
          <div>
            <router-link to="/personalcenters/myinfo">
              <div class="iconui">
                <i class="iconfont icon-icon-test-copy"></i>
              </div>
              <p>个人中心</p>
            </router-link>
          </div>
          <div v-if="$store.state.homeObj.xsbd_show == '1'" class="stuRegis" @click="gotoStuRegistration">
            <div class="iconui">
              <img src="../../assets/images/xsbd.png" alt="" />
            </div>
            <p>新生报到</p>
          </div>
          <div>
            <router-link to="/todos/list">
              <div class="iconui">
                <img src="../../assets/images/todoIcon.png" alt="" />
              </div>
              <p>
                待办事项（
                <span style="color: red">{{ unDoneLength }}</span>
                ）
              </p>
            </router-link>
          </div>
          <div>
            <router-link to="/personalcenters/forgetpassword">
              <div class="iconui"><i class="iconfont icon-xiugaimima"></i></div>
              <p>修改密码</p>
            </router-link>
          </div>
          <div>
            <router-link to="/myscore">
              <div class="iconui">
                <i class="iconfont icon-chengjibeifen"></i>
              </div>
              <p>我的成绩</p>
            </router-link>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="personalCenter-right"></div>

    <!-- 学籍切换子组件 -->
    <EnrollmentSwitch :visible.sync="switchModalVisible" :curStuId="userInfo.id" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EnrollmentSwitch from './EnrollmentSwitch.vue';
export default {
  name: 'PersonalCenter',
  components: {
    EnrollmentSwitch,
  },
  props: {
    Schoolprofile: String,
  },
  data() {
    return {
      userimge: 'https://qzapp.qlogo.cn/qzapp/101334430/AA65B61EF14DB10AED8B12A1611469A2/100',
      username: '林晓',
      grade: '2019',
      subject: '工商管理专业 ',
      arrangement: '专升本',
      state: false,
      showSwitchBtn: false, // 是否展示切换学籍按钮
      switchModalVisible: false, // 学籍切换组件展示状态
    };
  },
  computed: {
    ...mapState(['city', 'userInfo', 'unDoneLength']),
  },
  created() {
    this.$store.dispatch('getUndoneTodos');

    this.checkEnrollmentCount();
  },
  methods: {
    /**
     * 检查学生是否存在多学籍情况
     */
    checkEnrollmentCount() {
      this.axios
        .get('/biz/archive/getEnrollmentList')
        .then(res => {
          if (res.success && res.result && res.result.length > 1) {
            this.showSwitchBtn = true;
          } else {
            this.showSwitchBtn = false;
          }
        })
        .catch(() => {
          this.showSwitchBtn = false;
        });
    },

    /**
     * 显示多学籍切换弹框
     */
    openSwitchModal() {
      this.switchModalVisible = true;
    },

    gotoRouter() {
      this.$router.push(`/personalcenters/payment`);
    },
    gotoStuRegistration() {
      this.axios.get(`/biz/home/quick/xsbd`).then(res => {
        if (res.success) {
          window.open(res.result);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.header-width {
  width: $pageWidth;
  margin: 0 auto;
  margin-top: 20px;

  .personalCenter {
    background: #fff;
    display:flex;

    .userimage img {
      height: 94px;
      overflow: hidden;
    }

    .username {
      font-size: 28px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .grade {
        margin-left: 12px;
        font-size: 15px;
        color: #409eff;
        background-color: #ecf5ff;
        line-height: 1;
        border-radius: 20px;
        padding: 6px 12px;
      }

      .enroll-switch {
        margin-left: 12px;
        font-size: 14px;
        background-color: #f2f3f5;
        border-radius: 20px;
        padding: 4px 12px;
        display: inline-flex;
        align-items: center;
        height: 30px;

        .ant-btn-link {
          display: inline-flex;
          align-items: center;
          padding: 0;
          height: auto;

          .anticon {
            display: inline-flex;
            align-items: center;
            margin-right: -4px; // 图标与文字间距，可调整
            font-size: 14px;
          }
          span {
            line-height: 1;
            font-size: 14px;
          }
        }
      }
    }
  }

  .userinfo {
    color: #999;
    margin-top: 12px;

    strong {
      color: #333;
    }

    .text-red {
      color: #ff0000;
    }

    .text-green {
      color: #20d436;
    }
  }
  .site-info {
    color: #999;
    margin-top: 5px;
    display:flex;
    strong {
      color: #333;
    }
  }
}

.icons {
  text-align: center;
  padding-top: 30px;
  display: flex;
  justify-content: space-around;

  .stuRegis {
    cursor: pointer;
  }

  p {
    font-size: 14px;
    color: #999;
    margin-top: 20px;
  }

  .iconfont {
    font-size: 28px;

    &.icon-icon-test-copy {
      color: #f6ad3b;
    }

    &.icon-xiugaimima {
      font-size: 30px;
      color: #f5758a;
    }

    &.icon-chengjibeifen {
      color: #7eb6e6;
      font-size: 30px;
    }
  }
}

.flex-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.segmentation{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.top-semi-circle{
  width: 24px;
  height: 12px;
  background-color: rgb(234, 234, 234);
  border-radius:0 0 24px 24px;
}
.bottom-semi-circle{
  width: 24px;
  height: 12px;
  background-color: rgb(234, 234, 234);
  border-radius:24px 24px 0 0
}
.segmentation-center{
  height:100%;
  border-left:1px dashed rgb(234, 234, 234);
}
</style>



// WEBPACK FOOTER //
// src/common/components/PersonalCenter.vue